import { HSCodeState } from "@/modules/hs_code/types";
import { getHSCodes, saveHSCode, saveHSCodes, getHSCodeTypeByCode, getHSCodeTypes, getUnsetHSCodeItemsByType } from "@/services/hs_code";
import { RootState } from "@/store/types";
import { ActionTree, Module } from "vuex";

const actions: ActionTree<HSCodeState, RootState> = {
  async GET_HS_TYPE_BY_CODE(_, payload) {
    return await getHSCodeTypeByCode(payload);
  },
  async GET_UNSET_HS_CODE_ITEMS_BY_TYPE(_, payload) {
    return await getUnsetHSCodeItemsByType(payload);
  },
  async GET_HS_CODES(_, payload) {
    return await getHSCodes(payload);
  },
  async GET_HS_CODE_TYPES() {
    return await getHSCodeTypes();
  },
  async SAVE_HS_CODE(_, hsCode) {
    await saveHSCode(hsCode);
  },
  async SAVE_HS_CODES(_, payload) {
    await saveHSCodes(payload)
  }
}

export const hs_code: Module<HSCodeState, RootState> = {
  actions,
}
